// extracted by mini-css-extract-plugin
export default {"button":"IconButton-module__button___PZTOp","active":"IconButton-module__active___HzRVU"};